import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isOpen: [], // for active default menu
    defaultId: 'default',
    opened: true,
    showUserMenu: false, // 사원/관리자 메뉴 전환 상태
    isMobile: false // 모바일 접속 여부
};

export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        setMenu: (state, action) => {
            state.isOpen = [action.payload];
        },
        menuOpen: (state, action) => {
            state.opened = action.payload;
        },
        toggleUserMenu: (state) => {
            state.showUserMenu = !state.showUserMenu;
        },
        setUserMenu: (state, action) => {
            state.showUserMenu = action.payload;
        },
        setIsMobile: (state, action) => {
            state.isMobile = action.payload;
        }
    }
});

export const { menuOpen, setMenu, toggleUserMenu, setUserMenu, setIsMobile } = sidebarSlice.actions;

// 셀렉터 함수들
export const selectSidebarOpened = (state) => state.sidebar.opened;
export const selectSidebarIsOpen = (state) => state.sidebar.isOpen;
export const selectShowUserMenu = (state) => state.sidebar.showUserMenu;
export const selectIsMobile = (state) => state.sidebar.isMobile;

export default sidebarSlice.reducer;